import { render, staticRenderFns } from "./InnDialogsWrapper.vue?vue&type=template&id=4ed861ec"
import script from "./InnDialogsWrapper.vue?vue&type=script&lang=js"
export * from "./InnDialogsWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports